import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Layout from '../components/SSORegister';
import Encryption from '../encryption/encryption';

class SSORegisterContainer extends Component {
  constructor() {
    super();
    this.state = {
      error: null,
      success: null,
      loading: false,
      authToken: null,
      email: null,
      counter: 600,
    };
    this.timerId = null;
  }

  async componentDidMount() {
    this.startTimer();
    this.getQueryParams();
  }

  getQueryParams = () => {
    const { match } = this.props;
    const { email, token } = match.params;

    this.setState((value) => ({ ...value, authToken: this.decryptData(token), email: this.decryptData(email) }));
  };

  startTimer = () => {
    this.timerId = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.counter <= 1) {
          clearInterval(this.timerId);
          return { counter: 0 };
        }
        return { counter: prevState.counter - 1 };
      });
    }, 1000);
  };

  decryptData = (encodedData) => Encryption.AESdecryptData(encodedData);

  /**
   * On Form Submission
   */
  onFormSubmit = async (payload) => {
    const { ssoRegister, history, me } = this.props;
    const { email, authToken } = this.state;
    console.log(payload);
    this.setState({ success: null, error: null, loading: true });

    try {
      const { success, token, message } = await ssoRegister({
        ...payload,
        country_code: 'AE',
        email,
        token: authToken,
      });
      if (success) {
        this.setState({
          success,
          error: null,
          loading: false,
          message: '',
        });
        if (token) {
          me();
          history.push('/home');
        }
      } else {
        this.setState({ success, error: true, message, loading: false });
      }
    } catch (error) {
      this.setState({ loading: false, success: null, error: false, message: error.message });
    }
  };

  /**
   * Render
   */
  render = () => {
    const { error, loading, success, message, authToken, email, counter } = this.state;

    return (
      <Layout
        error={error}
        loading={loading}
        success={success}
        message={message}
        onFormSubmit={this.onFormSubmit}
        defaultValues={{ authToken, email }}
        counter={counter}
      />
    );
  };
}

SSORegisterContainer.propTypes = {
  userInput: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      email: PropTypes.string.isRequired,
      token: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  ssoRegister: PropTypes.func.isRequired,
  me: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  userInput: state.articles.userInput || {},
});

const mapDispatchToProps = (dispatch) => ({
  me: dispatch.member.me,
  ssoRegister: dispatch.member.ssoRegister,
});

export default connect(mapStateToProps, mapDispatchToProps)(SSORegisterContainer);
